import { AxiosResponse } from 'axios';
import { BaseService } from '@services/route.service';

export enum ELeadSignatureStatus {
    Sent = 0,
    Signed = 1,
    Cancelled = 2,
}

export interface LeadSignature {
    id: string;
    attachmentId: string;
    fileName: string;
    signers: { name: string; email: string; signedAt?: string | null }[];
    status: ELeadSignatureStatus;
    signedAt?: string | null;
    signedAttachmentId?: string | null;
    createdAt: string;
    sentByName?: string | null;
}

export class LeadSignatureService extends BaseService {
    protected get resourceName(): string {
        return 'crm';
    }

    public async status(): Promise<AxiosResponse<{ data: { configured: boolean } }>> {
        return await this.get('signatures/status');
    }

    public async list(leadId: string): Promise<AxiosResponse<{ data: LeadSignature[] }>> {
        return await this.get(`leads/${leadId}/signatures`);
    }

    public async send(
        leadId: string,
        body: { attachmentId: string; signers: { name: string; email: string }[] },
    ): Promise<AxiosResponse<{ data: LeadSignature }>> {
        return await this.post(body, `leads/${leadId}/signatures`);
    }
}
